import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";
import { ContainerTittle, LineTittle } from "./CommonStyles";

const TittleLine = ({
  title,
  text,
  maxWidthLine,
  weight,
  customButton = null,
}) => {
  return (
    <ContainerTittle>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          marginBottom: text ? "10px" : "0",
        }}
      >
        <Text size="24px" isTittle={true} weight={weight} margin={"0"}>
          {title}
        </Text>

        {customButton}
      </div>
      <LineTittle maxWidth={maxWidthLine} />

      <Text size="15px">{text}</Text>
    </ContainerTittle>
  );
};

TittleLine.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  maxWidthLine: PropTypes.string,
  weight: PropTypes.string,
  customButton: PropTypes.node,
};

export default TittleLine;
